const LocationType = {
    SET_LOCATION:'SET_LOCATION',
    SET_LOCATION_LIST_TO_VIEW:'SET_LOCATION_LIST_TO_VIEW',
    SET_DEPARTMENT_LIST:'SET_DEPARTMENT_LIST',
    SET_LOCATION_COUNTRY_AND_STATE:'SET_LOCATION_COUNTRY_AND_STATE'
  }
  export default LocationType;